module.exports = __webpack_public_path__ + "img/vue.8b8800e8.png";